// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a49b0ad1","977":"ddac7fa0"}[chunkId] + ".chunk.js";
};